import Vue from "vue";

import Btn from "../components/common/Btn.vue";
import IconBase from "../components/common/IconBase.vue";
import Container from "../components/common/Container.vue";

const components = {
  Btn,
  IconBase,
  Container,
};

for (let name in components) {
  Vue.component(name, components[name]);
}
